<app-catalog-page [loading]="loading"
                  [loaded]="loaded$ | async"
                  [sideMenuIds]="sideMenuIds$ | async"
                  [menuItems]="menuItems$ | async"
                  [productState]="productState$ | async"
                  [facetState]="facetState$ | async"
                  [combinedFacets]="combinedFacets$ | async"
                  [cartProducts]="cartProducts$ | async"
                  [favoritesProducts]="favoritesProducts$ | async"
                  [page]="currentPage$ | async"
                  [viewType]="viewType$ | async"
                  [viewTypeAdjustable]="viewTypeAdjustable$ | async"
                  [sideMenu]="sideMenu$ | async"
                  [activeChain]="activeChain$ | async"
                  [catalogItemPageSettings]="catalogItemPageSettings$ | async"
                  [catalogPageSettings]="catalogPageSettings$ | async"
                  [detailsPageSettings]="detailsPageSettings$ | async"
                  [searchPageSettings]="searchPageSettings$ | async"
                  [quantityPicker]="quantityPicker$ | async"
                  [allowOutOfStockOrdering]="allowOutOfStockOrdering"
                  (expand)="expandProducts()"
                  (toggleFacet)="facetToggled($event)"
                  (toggleShowMore)="groupToggled($event)"
                  (toggleOnlyStock)="onlyInStockToggled()"
                  (onDetails)="openDetails($event)"
                  (onAddCart)="addCart($event)"
                  (onFavoriteToggle)="toggleFavorite($event)"
                  (onTypeSwitched)="typeSwitch($event)"
                  (filterToggled)="onFilterToggled($event)"
                  [crumbs]="crumbs$ | async"
                  [showCrumbs]="showCrumbs"
                  [catalogSortOrders]="catalogSortOrders$ | async"
                  (sortOrderToggled)="onSortOrderToggle($event)"
                  [sortOrder]="sortOrder$ | async">
</app-catalog-page>
<router-outlet></router-outlet>
